import { Typography } from '@mui/material'
import { useSelector } from 'src/utils/store'
import { capitalizeString } from 'src/utils/capitalize'
import TextLabel from '../TextLabel/TextLabel'
import * as S from './UserIdentifier.styles'

const UserIdentifier = () => {
  const { receiveUser } = useSelector((state) => state.transfers)

  return (
    <S.Container>
      <Typography>Usuário:</Typography>
      <TextLabel>
        <Typography>{capitalizeString(receiveUser?.name || '')}</Typography>
      </TextLabel>
    </S.Container>
  )
}

export default UserIdentifier
